import React, { createElement, forwardRef, Ref, useCallback, useEffect, useState } from "react"
import { useQueryParam, StringParam } from "use-query-params";
import { navigate } from "gatsby"
import { Input, Button, Steps, notification } from 'antd'
import classNames from 'classnames'

import Layout from "../components/layout"
import { TranslationContainer, ApiContainer } from "../containers"
import Header from "../components/header"

import styles from "./step-1.module.less"
import FieldImg from "../images/group-8@3x.png"
import loader from "../images/loader.gif"
import HorizontalStepper from "../components/horizontal-stepper"
import CustomIcon from "../components/custom-icon"

import 'react-phone-number-input/style.css'
import PhoneInput, { getCountries } from 'react-phone-number-input'

const Onboarding1: React.FC<any> = ({ ...props }) => {
  const { currentLocale, translate } = TranslationContainer.useContainer();
  const [userName, setUserName] = useState<string>('');
  const [validUserName, setValidUserName] = useState<boolean>(false);
  const [errorUserName, setErrorUserName] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string>('');
  const [validEmail, setValidEmail] = useState<boolean>(false);
  const [errorEmail, setErrorEmail] = useState<boolean>(false);
  const [userPhone, setUserPhone] = useState<string>('');
  const [userCountry, setUserCountry] = useState<string>('');
  const [validPhone, setValidPhone] = useState<boolean>(false);
  const [errorPhone, setErrorPhone] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [catchYou, setCatchYou] = useState<string>('');
  const [defaultCountry, setDefaultCountry] = useState<string>('');
  const [isMobile, setIsMobile] = useQueryParam("mobile", StringParam);
  const { createLead, setLeadId, validateEmail, getLocationThroughIP, setUtmData } = ApiContainer.useContainer();
  const emailRegr = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const { Step } = Steps;

  //UTM Query Params
  const [campaign, setCampaign] = useQueryParam("utm_campaign", StringParam);
	const [source, setSource] = useQueryParam("utm_source", StringParam);
	const [medium, setMedium] = useQueryParam("utm_medium", StringParam);
	const [term, setTerm] = useQueryParam("utm_term", StringParam);
	const [content, setContent] = useQueryParam("utm_content", StringParam);

  const userNameIcon = createElement('div', {}, <CustomIcon isChecked={validUserName} showInvalid={errorUserName} />);
  const userEmailIcon = createElement('div', {}, <CustomIcon isChecked={validEmail} showInvalid={errorEmail} />);
  const userPhoneIcon = createElement('div', {}, <CustomIcon isChecked={validPhone} showInvalid={errorPhone} />)

  const userNameTitle = createElement('div', { className: styles.stepTitle }, translate("onboarding.nameTitle"));
  const userEmailTitle = createElement('div', { className: styles.stepTitle }, translate("onboarding.emailTitle"));
  const userPhoneTitle = createElement('div', { className: styles.stepTitle }, translate("onboarding.phoneTitle"));

  useEffect(() => {
    getDefaultCountry();
    const retrievedURLData = {
			utm_campaign: campaign,
			utm_source: source,
			utm_medium: medium,
			utm_term: term,
			utm_content: content,
		};
		setUtmData(retrievedURLData);
	}, [])

  const navigateToAgrapp = () => {
    navigate('https://www.agrapp.cl/');
  };

  const tailClass = (valid: boolean, activeError) => {
    if (valid && !activeError) {
      return styles.itemTailActive;
    } else if (!valid && activeError) {
      return styles.itemTailError;
    } else {
      return styles.itemTailInactative;
    }
  };

  const getDefaultCountry = async () => {
    try {
      const result = await getLocationThroughIP();
      const {country} = result;
      setDefaultCountry(country);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidPhonenumber = (value: string) => {
    return (/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ''));
  };

  const openNotificationWithIcon = (type, message?, description?) => {
    notification[type]({
      message: message ? message : translate("common.invalidData"),
      description: description ? description : translate("common.invalidDataDescription"),
    });
  };

  const validator = () => {
    let isValid = true;
    if (!validEmail) {
      setErrorEmail(true);
      isValid = false;
    }
    if (!validUserName) {
      setErrorUserName(true);
      isValid = false;
    }
    if (!validPhone) {
      setErrorPhone(true);
      isValid = false;
    }
    if (catchYou != '') {
      isValid = false;
    }
    return isValid;
  };

  const sendData = async (realData: boolean) => {
    if (validator()) {
      const contactInfo = {
        name: userName,
        email: userEmail,
        phone: userPhone,
        lang: currentLocale,
        real: realData,
        country: userCountry
      };
      try {
        setIsLoading(true);
        await validateEmail(contactInfo.email);
        const result = await createLead(contactInfo);
        setLeadId(result.id);
        if (realData) {
          navigate('/step-2/');
        } else {
          navigate('/step-3/');
        }
      } catch (error) {
        if (error.name == "TakenMail") {
          setErrorEmail(true);
          setValidEmail(false);
          openNotificationWithIcon('error', translate("onboarding.yourEmail"), translate("onboarding.takenEmail"));
        }
      } finally {
        setTimeout(()=>{setIsLoading(false)},1000);
      }
    } else {
      openNotificationWithIcon('error');
    }
  };

  const userNameInput = createElement(
    'div', {
    className: styles.inputStyle
  },
    <Input placeholder={translate("onboarding.yourName")}
      value={userName}
      onChange={(evt) => {
        setValidUserName(evt.target.value != '');
        setErrorUserName(false);
        setUserName(evt.target.value);
      }} />
  );

  const userEmailInput = createElement(
    'div', {
    className: styles.inputStyle
  },
    <Input placeholder={translate("onboarding.yourEmail")}
      value={userEmail}
      type="email"
      onChange={(evt) => {
        setValidEmail(emailRegr.test(evt.target.value));
        setErrorEmail(false);
        setUserEmail(evt.target.value);
      }} />
  );

  /*
  onChange={(evt) => {
        setValidPhone(isValidPhonenumber(evt.target.value));
        setErrorPhone(false);
        setUserPhone(evt.target.value.replace(/[\s()+\-\.]|ext/gi, ''));
      }}
  */

  const userPhoneInput = createElement(
    'div', {
    className: styles.phoneInput
  },
    <PhoneInput
      defaultCountry={defaultCountry}
      placeholder={translate("onboarding.yourPhone")}
      value={userPhone}
      onChange={(value) => {
        setValidPhone(isValidPhonenumber(value != undefined ? value : ''));
        setErrorPhone(false);
        setUserPhone(value);
      }}
      onCountryChange={setUserCountry} />
  );

  const domoArigatoMrRoboto = createElement(
    'div', {
    className: styles.inputStyle
  },
    <Input placeholder={translate("onboarding.yourPhone")}
      value={catchYou}
      type="text"
      onChange={(evt) => {
        setCatchYou(evt.target.value);
      }} />
  );

  const lastTailClass = classNames(tailClass(validPhone, errorPhone), styles.lastTail);

  return (
    <Layout>
      <div className={styles.viewWrapper}>
        <div className={styles.stepOneWrapper}>
          <Header backBtnAction={() => {
            navigateToAgrapp();
          }} />
          <div className={styles.stepOne}>
            <HorizontalStepper
              completedSteps={1}
              numberOfSteps={4} />
            <h1 className={styles.title}>{translate("onboarding.startForFree")}</h1>
            <h4 className={styles.subtile}>{isMobile != null ? translate("onboarding.trialPeriodMobile") : translate("onboarding.trialPeriodMobile")}</h4>
            <div className={styles.fieldWrapper}>
              <Steps direction="vertical" size="small" current={2}>
                <Step className={tailClass(validUserName, errorUserName)} icon={userNameIcon} title={userNameTitle} description={userNameInput} />
                <Step className={tailClass(validEmail, errorEmail)} icon={userEmailIcon} title={userEmailTitle} description={userEmailInput} />
                <Step className={lastTailClass} icon={userPhoneIcon} title={userPhoneTitle} description={userPhoneInput} />
                <Step className={styles.mrRoboto} description={domoArigatoMrRoboto} />
              </Steps>
            </div>
            <div className={styles.btnWrapper}>
              <Button type="primary"
                onClick={() => {
                  sendData(true);
                }}>
                {loading ? (<img src={loader} />) : (translate("onboarding.continueAndConfigure"))}
              </Button>
              <a className={styles.testDataWrap}
                onClick={() => {
                  sendData(false);
                }}>
                {translate("onboarding.createFieldWithTestData")}
              </a>
            </div>
            <div className={styles.footerImage}>
              <img src={FieldImg} />
            </div>
          </div>
        </div>
        <div className={styles.lateralImage}>
          <div className={styles.testimonyWrapper}>
            <div className={styles.innerWrapper}>
              <div className={styles.legends}>
                <div className={styles.title}>
                  {translate("onboarding.costControl")}
                </div>
                <div className={styles.subtitle}>
                  {translate("onboarding.costInformation")}
                </div>
                <div className={styles.separator}>
                </div>
                <div className={styles.subInfo}>
                  {translate("onboarding.allCrops")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Onboarding1
